import React, { CSSProperties, ReactNode } from 'react';

type LinearGradientProps = {
  children?: ReactNode;
  style?: CSSProperties | CSSProperties[];
  colors?: readonly string[];
  start?: { x: number; y: number };
  end?: { x: number; y: number };
};

// Minimal web shim for expo-linear-gradient
export const LinearGradient: React.FC<LinearGradientProps> = ({ children, style, colors, start, end }) => {
  const styleArray = Array.isArray(style) ? style : style ? [style] : [];
  const mergedStyle: CSSProperties = Object.assign({}, ...styleArray);

  // Optional: approximate gradient using CSS if colors provided
  if (colors && colors.length >= 2) {
    const angle = (() => {
      const sx = start?.x ?? 0;
      const sy = start?.y ?? 0;
      const ex = end?.x ?? 1;
      const ey = end?.y ?? 1;
      const rad = Math.atan2(ey - sy, ex - sx);
      return (rad * 180) / Math.PI; // degrees
    })();
    mergedStyle.backgroundImage = `linear-gradient(${angle}deg, ${colors.join(', ')})`;
  }

  return React.createElement('div', { style: mergedStyle }, children);
};

export default LinearGradient;